import TaskList from "./TaskList";

function IndexV2(props) {
	return (
		<div>
			<TaskList {...props} />
		</div>
	);
}

export default IndexV2;
